import { Injectable } from "@angular/core";
import { DwdmDiagramAbstractConverterTransponders } from "../../diagram/converter/dwdm-diagram-abstract-converter-transponders";
import { TranspondersConverterData } from "../../diagram/converter/dwdm-diagram-converter.models";
import { CircuitElementState, TransponderElement, TransponderMultirate } from "../../diagram/models/diagram.models";

/**
 * Implementação da @see DwdmDiagramAbstractConverterTransponders para a wizard de criação de circuitos DWDM.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmDiagramWizardConverterTranspondersService extends DwdmDiagramAbstractConverterTransponders {

    private readonly DEFAULT_MULTIRATE = TransponderMultirate.MULTIRATE_4X_100;

    public convert(transpondersData: TranspondersConverterData): TransponderElement[] {
        return super.convertData(transpondersData, () => {});
    }

    /**
     * Se não há slots ou portas configuradas, isso indica que estamos no estado inicial do diagrama e todos os
     * transponders serão criados com multirate 4X_100 e na cor cinza ou azul claro.
     */
    protected shouldBuildDefaultTransponders(transpondersData: TranspondersConverterData): boolean {
        const slots = transpondersData.slots;
        const ports = transpondersData.ports;
        const hasSlots = slots.length > 0;
        const hasPorts = ports.length > 0;

        return !hasSlots || !hasPorts;
    }

    /**
     * Cria os transponders iniciais. São sempre 4 por equipamento.
     */
    protected buildDefaultTransponders(transpondersData: TranspondersConverterData): TransponderElement[] {
        const transponders = [];
        const isInitialState = transpondersData.slots.length === 0;
        const state = isInitialState ? CircuitElementState.INITIAL : CircuitElementState.NOT_CONFIGURED;

        while (transponders.length < 4) {
            const transponder = this.createTransponder(state, this.DEFAULT_MULTIRATE);

            transponders.push(transponder);
        }

        return transponders;
    }
}
